/**
 * Async key/value storage for PowerSync auth tokens.
 *
 * Web / Tauri build → `localStorage` (synchronous under the hood, wrapped to satisfy
 * the async interface required by `BasePowerSyncConnector`).
 *
 * The exported `tokenStorage` wraps localStorage asynchronously, matching the existing pattern.
 */

import type { TokenStorage } from "@time-tracker/shared";

export const tokenStorage: TokenStorage = {
  // oxlint-disable-next-line typescript-eslint/require-await
  getItem: async (key) => localStorage.getItem(key),
  // oxlint-disable-next-line typescript-eslint/require-await
  setItem: async (key, value) => {
    localStorage.setItem(key, value);
  },
};
